/**
 * useChannel2.js — RC 1.62 Phase D hook.
 *
 * Reads the `channel_2` projection off /api/employer/v1/me and
 * surfaces it to UI consumers. Fail-closed (returns `enabled:false`)
 * on any error — never optimistically activate Channel-2.
 *
 * Re-fetch is opt-in via the returned `refresh()` so signal-send
 * paths can immediately update the remaining-signals counter.
 */
import { useCallback, useEffect, useState } from 'react';
import { apiFetch } from './api';

const DORMANT = Object.freeze({
  enabled:           false,
  signals_allowance: null,
  signals_used:      null,
  signals_remaining: null,
});

export function useChannel2() {
  const [state, setState] = useState({ ...DORMANT, loading: true });

  const refresh = useCallback(async () => {
    try {
      const me = await apiFetch('/api/employer/v1/me');
      const c  = me?.channel_2 || DORMANT;
      setState({
        enabled:           Boolean(c.enabled),
        signals_allowance: c.signals_allowance ?? null,
        signals_used:      c.signals_used ?? null,
        signals_remaining: c.signals_remaining ?? null,
        loading:           false,
      });
    } catch {
      setState({ ...DORMANT, loading: false });
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { ...state, refresh };
}
